module.exports = __webpack_public_path__ + "static/launcher-fed4cdbe1a494641d82fb3f9efae25dd.png";